// MEMO: import this for IE11.
// MEMO: Swiper 5.4.5 works on IE11.
// import Swiper from "../../node_modules/swiper/js/swiper";

// import the latest version
import Swiper, { Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Autoplay]);

/*
 *
 * ----------------------------------------------- */
var swiperVoicescard = document.querySelector(".swiper-voices-card");

if (swiperVoicescard) {
  new Swiper(swiperVoicescard, {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 20,
    speed: 6000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
  });
}
